import { useState, useRef, useEffect, SetStateAction } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../Components/Navbar";
import Button from "react-bootstrap/Button";
import { useForm } from "react-hook-form";
import { useAuthContext } from "../../hooks";
import { createPerformance } from "../../api/performance/createPerformance";
import { getOrgUserGoals } from "../../api/performance/getOrgUserGoals";
import { createGoals } from "../../api/performance/createGoals";
import { getOrgUsersProjects } from "../../api/project/getOrgUserProjects";
import Modal from "react-bootstrap/Modal";
import Goals from "./goal";
import "./style.css";
import { getOrgGoalType } from "../../api/OrganizationGoal/getOrgGoalType";
import { createOrggoals } from "../../api/OrganizationGoal/createOrgGoals";
import { getOrgGoal } from "../../api/OrganizationGoal/getOrgGoal";
import ReactQuill from "react-quill";
import { parse } from "path";
import { getObjectiveTpe } from "../../api/performance/getObjectiveType";
import Form from "react-bootstrap/Form";
import MagSc from "./index.sc";
function Index() {
  const [formData, setFormData] = useState({
    goalRoleId: "",
    goal: "",
    due_date: "",
  });
  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  };
  const handleGoalChange = (value: any) => {
    setFormData((prevFormData) => ({ ...prevFormData, goal: value }));
    console.log(formData.goal);
  };

  const [projectGoalsSuccess, setProjectGoalSuccess] = useState(false);
  const [projectGoaldata, setProjectGoalData] = useState({
    project_id: "",
    due_date: "",
    goals: "",
  });

  const handleProjectGoalChange = (e: any) => {
    const { name, value } = e.target;
    console.log(name, value);
    setProjectGoalData((prevProjectGoalData) => ({
      ...prevProjectGoalData,
      [name]: value,
    }));
    console.log(projectGoaldata);
  };
  const handleIndividualProjectGoalChange = (value: any) => {
    setProjectGoalData((prevProjectGoalData) => ({
      ...prevProjectGoalData,
      goals: value,
    }));
  };
  const [isFormValid, setIsFormValid] = useState(false);

  const validateProjectGoalForm = () => {
    if (
      projectGoaldata.project_id &&
      projectGoaldata.due_date &&
      projectGoaldata.goals
    ) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  };

  const validateOrgGoalForm = () => {
    if (formData.goalRoleId && formData.due_date && formData.goal) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  };

  const handleSubmited = async (e: any) => {
    console.log(projectGoaldata);
    e.preventDefault();
    if (
      projectGoaldata.project_id &&
      projectGoaldata.due_date &&
      projectGoaldata.goals
    ) {
      try {
        const response = await createGoals(
          auth?.userInfo?.orgs[0]?.id,
          {
            ...projectGoaldata,
            project_id: Number(projectGoaldata.project_id),
          },

          auth?.userInfo?.orgs_user_id[0]
        );
        console.log(response);
        setProjectGoalData({ project_id: "", due_date: "", goals: "" });
        setShow2(false);
      } catch (error) {
        console.log(error);
      }
    } else {
      alert("please fill all the data in the project goals filed");
    }
  };
  const handleSubmits = async (e: any) => {
    e.preventDefault();
    if (formData.goalRoleId && formData.goal && formData.due_date) {
      try {
        const response = await createOrggoals(
          auth?.userInfo?.orgs[0]?.id,
          auth?.userInfo?.orgs_user_id[0],
          formData
        );
        console.log(response);

        setFormData({ goalRoleId: "", goal: "", due_date: "" });
        validateOrgGoalForm();
        setShow2(false);
      } catch (error) {
        console.log(error);
      }
    }
  };
  const [objective, setobjective] = useState({
    Evaluation: "",
    objective: "",
    object_role_id: "",
  });
  const handleobjectiveChange = (e: any) => {
    const { name, value } = e.target;
    console.log(name, value);
    setobjective((prevObjective) => ({
      ...prevObjective,
      [name]: name == "object_role_id" ? Number(value) : value,
    }));
    console.log(objective);
  };
  const handleDevelopmentObjectiveChange = (value: any) => {
    setobjective((prevObjective) => ({
      ...prevObjective,
      objective: value,
    }));
  };
  const handleSubmitobjective = async (e: any) => {
    console.log(objective);
    e.preventDefault();
    if (
      objective.Evaluation &&
      objective.objective &&
      objective.object_role_id
    ) {
      try {
        const response = await createPerformance(
          auth?.userInfo?.orgs[0]?.id,
          { ...objective },

          auth?.userInfo?.orgs_user_id[0]
        );
        console.log(response);

        setobjective({ Evaluation: "", objective: "", object_role_id: "" });
        setShow1(false);
      } catch (error) {
        console.log(error);
      }
    } else alert("Please Submit the required fields");
  };

  const onSubmit = async (e: any) => {
    await handleSubmitobjective(e);
  };
  const [getobjective, getSetObjective] = useState<any[]>([]);
  const fetchobjectiveType = async () => {
    await getObjectiveTpe(auth?.userInfo?.orgs[0]?.id)
      .then((e) => {
        console.log(e);
        getSetObjective(e);
      })
      .catch((e) => console.log(e));
  };
  console.log(getobjective);
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  const auth = useAuthContext();
  const [orgGoals, setOrgGoals] = useState<any[]>([]);
  const fetchOrgGoals = async () => {
    await getOrgGoal(
      auth?.userInfo?.orgs[0]?.id,
      auth?.userInfo?.orgs_user_id[0]
    )
      .then((e: SetStateAction<any[]>) => {
        console.log(e);
        setOrgGoals(e);
      })
      .catch((e: any) => console.log(e));
  };
  console.log(auth?.userInfo?.orgs_user_id[0]);
  const [getProjects, SetGetProjects] = useState<any[]>([]);
  const [getOrgGoaltype, setGetOrgGoaltype] = useState<any[]>([]);
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const handleFocus = () => {
    if (textareaRef.current) {
      textareaRef.current.focus();
    }
  };
  const fetchOrgUserProjects = async () => {
    await getOrgUsersProjects(
      auth?.userInfo?.orgs[0]?.id,
      (auth?.userInfo?.orgs_user_id[0]).toString()
    )
      .then((e) => {
        console.log(e);
        SetGetProjects(e);
      })
      .catch((e) => console.log(e));
  };
  const fetchAllOrgGoalType = async () => {
    await getOrgGoalType(auth?.userInfo?.orgs[0]?.id)
      .then((e) => {
        console.log(e);
        setGetOrgGoaltype(e);
      })
      .catch((e) => console.log(e));
  };
  const handleCreatePerformance = async (e: any) => {
    console.debug("data > ", e);
    await createPerformance(
      auth?.userInfo?.orgs[0]?.id,
      {
        ...e,
        created_by: (auth?.userInfo?.id).toString(),
      },
      auth?.userInfo?.orgs_user_id[0]
    )
      .then((e: any) => {
        console.log(e);
      })
      .catch((err) => {
        console.log("============");
        console.log(err);
      });
  };

  const handleCreateOrgGoals = async (e: any) => {
    console.debug("data > ", e);
    await createOrggoals(
      auth?.userInfo?.orgs[0]?.id,
      auth?.userInfo?.orgs_user_id[0],
      e
    )
      .then((e: any) => {
        console.log(e);
      })
      .catch((err) => {
        console.log("============");
        console.log(err);
      });
  };

  const onSubmitPerformance = async (e: any) => {
    console.log(e);
    reset();
    await handleCreatePerformance(e);
  };

  const navigate = useNavigate();
  const [fullscreen, setFullscreen] = useState(true);

  const handleClose1 = () => setShow1(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  function handleShow1(breakpoint: any) {
    setShow1(true);
  }
  function handleShow(breakpoint: any) {
    setShow(true);
  }
  function handleShow2(breakpoint: any) {
    setShow2(true);
    setFullscreen(breakpoint);
  }

  useEffect(() => {
    fetchOrgUserProjects();
    fetchAllOrgGoalType();
    fetchOrgGoals();
    fetchobjectiveType();
  }, []);
  return (
    <MagSc>
      <div>
        <h1>PERFORMANCE MANAGEMENT</h1>
        <Button variant="primary" onClick={handleShow1} className="rpm-button">
          Apply Objective
        </Button>
        <Button variant="primary" onClick={handleShow2} className="rpm-button">
          Add Goals
        </Button>

        <Modal
          id="AddRpm"
          className="modal-objective"
          show={show1}
          onHide={() => setShow1(false)}
          size="lg"
          height="100"
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              Apply PPM
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={onSubmit}>
              <div className="objective-modal">
                <div className="evaluation-objective-container">
                  <div className="evaluation-container">
                    <label>Evaluation</label>
                    <Form.Select
                      className="evaluation"
                      onChange={handleobjectiveChange}
                      name="Evaluation"
                      value={objective.Evaluation}
                    >
                      <option disabled value="">
                        Select Year
                      </option>
                      <option value="2022">2022</option>
                      <option value="2023">2023</option>
                      <option value="2024">2024</option>
                      <option value="2025">2025</option>

                    </Form.Select>
                  </div>
                  <div className="objective-container">
                    <label>Development Objective</label>
                    <Form.Select
                      className="objective"
                      onChange={handleobjectiveChange}
                      name="object_role_id"
                    >
                      <option>Select Type</option>
                      {getobjective?.map((data: any) => {
                        return (
                          <>
                            <option value={data?.or_id}>{data?.or_name}</option>
                          </>
                        );
                      })}
                    </Form.Select>
                  </div>
                </div>
                <label>What to achieve</label>
                <ReactQuill
                  value={objective.objective}
                  onChange={handleDevelopmentObjectiveChange}
                />

                <Button
                  type="submit"
                  className="objective-submit"
                  // onClick={() => {
                  //   handleFocus();
                  //   handleClose();
                  // }}
                >
                  Submit
                </Button>
              </div>
            </form>
          </Modal.Body>
        </Modal>
        <Modal
          id="AddRpm"
          className="modal-objective"
          show={show2}
          onHide={() => setShow2(false)}
          size="lg"
          backdrop="static"
        >
          <Modal.Header
            closeButton
            style={{ backgroundColor: "#f8f9fa", color: "#212529" }}
          >
            <Modal.Title id="example-modal-sizes-title-lg">
              Project Goals
            </Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{
              color: "black",
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
              backgroundColor: "#f8f9fa",
            }}
          >
            <div>
              <form onSubmit={handleSubmited}>
                <div className="objective-modal">
                  <div className="goals-heading">
                    <Form.Select
                      className="project"
                      value={projectGoaldata.project_id}
                      onChange={handleProjectGoalChange}
                      name="project_id"
                      style={{ width: "220px" }}
                    >
                      <option disabled value="">
                        Please Select Project
                      </option>
                      {getProjects?.map((data) => {
                        return (
                          <>
                            <option value={data?.ProjectId}>
                              {data?.ProjectName}
                            </option>
                          </>
                        );
                      })}
                    </Form.Select>
                    <div className="due-date">
                      <label>Due Date:</label>
                      <input
                        className="due-dates"
                        type="date"
                        value={projectGoaldata.due_date}
                        onChange={handleProjectGoalChange}
                        name="due_date"
                      />
                    </div>
                  </div>

                  <div className="objective-modal-main">
                    <label htmlFor="description">Goals:</label>
                    <ReactQuill
                      value={projectGoaldata.goals}
                      onChange={handleIndividualProjectGoalChange}
                    />
                    <button
                      type="submit"
                      className="objective-submit"
                      onClick={() => {
                        handleFocus();
                        handleClose();
                      }}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <Modal.Title id="example-modal-sizes-title-lg">
              Org Goals
            </Modal.Title>

            <div>
              <form onSubmit={handleSubmits}>
                <div className="objective-modal">
                  <div className="goals-heading">
                    <Form.Select
                      onChange={handleChange}
                      name="goalRoleId"
                      className="project"
                      style={{ width: "200px" }}
                    >
                      <option disabled value="">
                        Please Select Org Goal Type
                      </option>
                      {getOrgGoaltype?.map((data: any) => {
                        return (
                          <>
                            <option value={data?.id}>{data?.name}</option>
                          </>
                        );
                      })}
                    </Form.Select>

                    <div className="due-date">
                      <label>Due Date:</label>
                      <input
                        className="due-dates"
                        type="date"
                        value={formData.due_date}
                        onChange={handleChange}
                        name="due_date"
                      />
                    </div>
                  </div>

                  <div className="objective-modal-main">
                    <label htmlFor="description">Description:</label>
                    <ReactQuill
                      value={formData.goal}
                      onChange={handleGoalChange}
                    />
                    <button
                      type="submit"
                      className="objective-submit"
                      onClick={() => {
                        handleFocus();
                        handleClose();
                      }}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </Modal.Body>
        </Modal>
        <Goals />
      </div>
    </MagSc>
  );
}

export default Index;
